import { ActionTypes as types } from 'constants';

export default stateCode => dispatch => {
  dispatch({
    type: types.UPDATE_STATE_CODE,
    payload: stateCode,
  });
};
